export const ASSIGNEE_CHANGE_SUCCESS_MSG = 'Assignee was changed successfully';
